import React from "react";
import globalHook from "use-global-hook";
import actions from "./actions/index";
const initialState = {
  isloggedIn: localStorage.getItem("user"),
  signupNew: false,
  signupError: null,
  showFilters: false,
  loading: false,
  postRequirements: null,
  error: "",
  isOnboarding: true,
  filters: null,
  products:null,
  createCollection:null,
  userCategories:null,
  collections:null,
  selectedProdutcs:[],
  buyerCollectionData:null,
  shortlistedProducts:[],
  collection_link:null,
  queriesData:null,
  editCollectionProducts:null,
  tableInternalColumns:null,
  permissions:null
};

export const useGlobal = globalHook(React, initialState, actions);
